<template>
  <img
    :src="imageUrl"
    :alt="alt"
    loading="lazy"
    class="dish-image"
  />
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { tenantId } from '@/utils/tenantUrl'

const props = defineProps({
  fileId: {
    type: [String, Number],
    required: true
  },
  alt: {
    type: String,
    default: '菜品图片'
  }
})

const imageUrl = computed(() => {
  return `/file/image?id=${props.fileId}&x-tenant=${tenantId}`
})
</script>

<style scoped>
.dish-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>